import { ImageError } from '@core/components/ImageViewer/ImageError';
import { ImageLoading } from '@core/components/ImageViewer/ImageLoading';
import * as styles from '@core/components/ImageViewer/ImageViewer.css';

export interface ImageContentProps {
  imageUrl: string;
  altText: string;
  isSafe: boolean;
  isBlurred: boolean;
  imageLoading: boolean;
  imageLoadError: boolean;
  onImageLoad: () => void;
  onImageError: () => void;
}

/**
 * Image content with loading and error states
 */
export function ImageContent({ imageUrl, altText, isSafe, isBlurred, imageLoading, imageLoadError, onImageLoad, onImageError }: ImageContentProps) {
  const imageClassName = `${styles.image} ${!isSafe && isBlurred ? styles.blurredImage : ''}`;

  return (
    <>
      {imageLoading && !imageLoadError && <ImageLoading />}
      {imageLoadError && <ImageError imageUrl={imageUrl} />}
      {!imageLoadError && (
        <img
          alt={altText}
          className={imageClassName}
          src={imageUrl}
          style={{ display: imageLoading ? 'none' : 'block' }}
          onError={onImageError}
          onLoad={onImageLoad}
        />
      )}
    </>
  );
}
